export enum WallStyle {
  ColumnAngleBlocks = 'column-angle-blocks',
  FullyEnclosed = 'fully-enclosed',
  Gable = 'gable',
  LeftEnclosed = 'left-enclosed',
  LeftEnclosedGable = 'left-enclosed-gable',
  Open = 'none',
  RightEnclosed = 'right-enclosed',
  RightEnclosedGable = 'right-enclosed-gable',
}
